export default {
  Link: {
    baseStyle: {
      color: 'brand.500',
      _hover: { color: 'brand.600' },
      _focus: { boxShadow: 'none' },
    },
  },
};
